import React, { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { useUserEmail } from "@nhost/react";
import { UPDATE_USER_STATUS } from "./queries";

import UserCard from "./UserCard";
import CreateUsers from "./CreateUsers";
import Loader from "./Loader"
import {useAdminContext} from "../../contexts/AdminContext"

import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';





const UsersList: React.FC = () => {

  // ✅ Ajout d'un état pour rafraîchir la liste des utilisateurs
  const [refreshUsersTrigger, setRefreshUsersTrigger] = useState(0);

  // Chargement du contexte
  const {usersQuery} = useAdminContext();

  const [updateUserStatus] = useMutation(UPDATE_USER_STATUS);
  const userEmail = useUserEmail(); // ✅ Récupérer l'email de l'utilisateur connecté


  const handleUserCreated = () => {
    setRefreshUsersTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    usersQuery.refetch();
  }, [refreshUsersTrigger, usersQuery.refetch]);



  if (usersQuery.error) return <p>Erreur : {usersQuery.error.message}</p>;

  const handleToggleStatus = async (email: string, currentStatus: boolean) => {
    try {
      const normalizedEmail = email.trim().toLowerCase();
      await updateUserStatus({
        variables: { email: normalizedEmail, disabled: !currentStatus },
      });
      await usersQuery.refetch();
    } catch (err) {
      console.error("Erreur lors de la mise à jour :", err);
    }
  };

  return (
      <Card className="flex-fill">
        <Card.Header className="d-flex align-items-center justify-content-between g-4">
        <h2 className="mb-0 fs-2">Liste des utilisateurs</h2> <CreateUsers onUserCreated={handleUserCreated} />
        </Card.Header>

        <Card.Body style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <Loader loading={usersQuery.loading} error={usersQuery.error}>
            <ListGroup variant="flush">
                  {usersQuery.data?.users?.length ? (
                      [...usersQuery.data.users].sort((a, b) => a.email.localeCompare(b.email)).map((user) => {
                        if (user.email === userEmail) return null; // ✅ Masquer l'utilisateur actuel

                        return <UserCard key={user.id} user={user} handleToggleStatus={handleToggleStatus} />
                          
                      })
                    ) : (
                      <p className="text-gray-500">Aucun utilisateur trouvé.</p>
                  )}
                </ListGroup>
          </Loader>
        </Card.Body>
      </Card>
  );
};

export default UsersList;

